module.exports = __webpack_public_path__ + "static/github-3ac05a15e9b50d11113e54d2a70c6e7d.png";